import { Form, Formik } from 'formik';
import React from 'react';
import { Mutation, Query } from 'react-apollo';
import { Box, Button, Flex, Heading } from 'rebass';
import CheckboxInput from '../../../components/CheckboxInput';
import FormField from '../../../components/FormField';
import TextInput from '../../../components/TextInput';
import { ADMIN_CREATE_THYROID_PROGRAMS, ADMIN_GET_COURSE_PAYMENT_SCREEN, ADMIN_GET_THYROID_PROGRAMS } from '../../../graphql';
import styled from 'styled-components';
import { useState } from 'react';
import EditPaymentScreen from './EditPaymentScreen';
import PleaseWait from '../../../components/PleaseWait';
import ConfirmModal from '../../../components/ConfirmModal';

const ModalInner = styled(Box)`
  max-width: 80vw;
  width: 80vw;
  max-height: 90vh;
  overflow-y: auto;
`;
const AddPresetPlan = ({ onSave, onClose, initialValues }) => {
  const [isEditPaymentScreen, setIsEditPaymentScreen] = useState(false);

  return (
    <>
      {!isEditPaymentScreen ? (
        <Mutation
          mutation={ADMIN_CREATE_THYROID_PROGRAMS}
          refetchQueries={[{ query: ADMIN_GET_THYROID_PROGRAMS }]}
          awaitRefetchQueries={true}
          onCompleted={() => {
            onSave();
          }}
        >
          {(createPlan, { loading }) => (
            <Formik
              isInitialValid={
                ({ initialValues }) => true
                //   schema.isValidSync(initialValues)
              }
              initialValues={{ ...initialValues }}
              // validationSchema={schema}
              onSubmit={async (values, actions) => {
                let vars = {
                  id: (initialValues || {}).id,
                  name: values.name,
                  description: values.description,
                  icon: values.icon,
                  bgMainColor: values.bgMainColor,
                  bgBubblesColor: values.bgBubblesColor,
                  titleColor: values.titleColor,
                  descriptionColor: values.descriptionColor,
                  isActive: values.isActive,
                  isArchived: values.isArchived,
                  isPro: values.isPro,
                  memberOnly: values.memberOnly,
                  assignedOnly: values.assignedOnly,
                  stripePriceId: values.stripePriceId,
                };

                await createPlan({
                  variables: {
                    ...vars,
                  },
                });
                // submitCheck(values, actions)
              }}
              render={({ touched, errors, isValid, handleChange, handleBlur, isSubmitting, setFieldValue, setFieldTouched, values }) => (
                <Form>
                  <Flex flexDirection="column" width="400px" style={{ maxHeight: '900px' }}>
                    <FormField mb={4} error={touched.name && errors.name}>
                      <label for="name">Name</label>
                      <TextInput name="name" placeholder="Name" />
                    </FormField>
                    <FormField mb={4} error={touched.description && errors.description}>
                      <label for="description">Description</label>
                      <TextInput name="description" placeholder="Description" />
                    </FormField>

                    <FormField mb={4} error={touched.phone && errors.phone}>
                      <label for="icon">Icon</label>
                      <TextInput name="icon" placeholder="Icon" />
                    </FormField>

                    <FormField mb={4} error={touched.bgMainColor && errors.bgMainColor}>
                      <label for="bgMainColor">Screen Background Color</label>
                      <TextInput name="bgMainColor" placeholder="Screen Background Color" />
                    </FormField>

                    <FormField mb={4} error={touched.bgBubblesColor && errors.bgBubblesColor}>
                      <label for="bgBubblesColor">Hormones Background Color</label>
                      <TextInput name="bgBubblesColor" placeholder="Hormones Background Color" />
                    </FormField>

                    <FormField mb={4} error={touched.titleColor && errors.titleColor}>
                      <label for="titleColor">Title Color</label>
                      <TextInput name="titleColor" placeholder="Title Color" />
                    </FormField>

                    <FormField mb={4} error={touched.titleColor && errors.titleColor}>
                      <label for="descriptionColor">Description Color</label>
                      <TextInput name="descriptionColor" placeholder="Description Color" />
                    </FormField>

                    <Flex>
                      <FormField flex={1} mb={4} error={touched.phone && errors.phone}>
                        <label for="isPro">Requires Pro subscription</label>
                        <CheckboxInput
                          name="isPro"
                          styles={{
                            checked: {
                              Box: {
                                backgroundColor: 'rgb(54, 79, 121)',
                              },
                            },
                          }}
                        />
                      </FormField>
                      <Button
                        disabled={!(initialValues || {}).id}
                        variant={'pink'}
                        type="button"
                        style={{ padding: '4px 8px', height: 'fit-content' }}
                        onClick={() => {
                          setIsEditPaymentScreen(true);
                        }}
                      >
                        Edit Payment Screen
                      </Button>
                    </Flex>

                    <FormField mb={4} error={touched.stripePriceId && errors.stripePriceId}>
                      <label for="stripePriceId">Stripe Price ID</label>
                      <TextInput name="stripePriceId" placeholder="Stripe Price ID" />
                    </FormField>
                    <FormField mb={4} error={touched.phone && errors.phone}>
                      <label for="assignedOnly">Accessible only to patients assigned by HC</label>
                      <CheckboxInput
                        name="assignedOnly"
                        styles={{
                          checked: {
                            Box: {
                              backgroundColor: 'rgb(54, 79, 121)',
                            },
                          },
                        }}
                      />
                    </FormField>
                    <FormField mb={4} error={touched.phone && errors.phone}>
                      <label for="isActive">Is Active</label>
                      <CheckboxInput
                        name="isActive"
                        styles={{
                          checked: {
                            Box: {
                              backgroundColor: 'rgb(54, 79, 121)',
                            },
                          },
                        }}
                      />
                    </FormField>

                    <Button
                      variant={'primary'}
                      type="button"
                      onClick={() => {
                        setIsEditPaymentScreen(true);
                      }}
                    >
                      Edit Payment Screen
                    </Button>

                    <Flex mt={4} flexDirection="row" alignItems="center" justifyContent="space-between">
                      <Button
                        style={{
                          background: 'white',
                          color: '#344f79',
                          border: '1px solid #344f79',
                        }}
                        type="button"
                        onClick={onClose}
                      >
                        Cancel
                      </Button>
                      <Button
                        // disabled={!isValid}
                        style={{ background: '#344f79' }}
                        onClick={() => {
                          // createCategory();
                        }}
                      >
                        Save
                      </Button>
                    </Flex>
                  </Flex>
                </Form>
              )}
            />
          )}
        </Mutation>
      ) : null}

      <ConfirmModal
        childrenManaged
        isOpen={isEditPaymentScreen}
        confirmLabel="create"
        onClose={() => {
          setIsEditPaymentScreen(false);
        }}
        onBackgroundClick={() => {
          setIsEditPaymentScreen(false);
        }}
        onEscapeKeydown={() => {
          setIsEditPaymentScreen(false);
        }}
        onConfirm={() => {
          setIsEditPaymentScreen(false);
        }}
      >
        <ModalInner>
          <Heading fontSize="20px" mb={'20px'}>
            EDIT PAYMENT SCREEN
          </Heading>
          <Query query={ADMIN_GET_COURSE_PAYMENT_SCREEN} variables={{ courseId: (initialValues || {}).id }}>
            {({ loading, data }) => {
              if (!!loading) return <PleaseWait />;
              console.log({ data });
              return (
                <EditPaymentScreen
                  initialValues={(data || {}).getMobileCoursePaymentScreen}
                  courseId={(initialValues || {}).id}
                  onSave={() => setIsEditPaymentScreen(false)}
                  onClose={() => setIsEditPaymentScreen(false)}
                />
              );
            }}
          </Query>
        </ModalInner>
      </ConfirmModal>
    </>
  );
};

export default AddPresetPlan;
